import { FullName } from '@nemuru-eng/js-api-client';

export const getFullNameString = (fullName: FullName | null | undefined): string | undefined => {
  const hasFirstName = !!fullName?.firstName;

  if (hasFirstName) {
    return `${fullName.firstName} ${fullName.lastName}`;
  }
};
